/**
 * Estamos dentro do APLICATIVO instalado (e não no navegador)?
 *
 * Mora sozinho, longe do plugin do Capacitor, porque quem só precisa
 * SABER onde está — a captura do local ao publicar no diário, por exemplo —
 * não deve carregar o plugin de notificação junto, nem depender de um
 * `import()` que pode não responder no meio de uma publicação.
 */
export function isNativeApp(): boolean {
  if (typeof window === "undefined") return false;
  const bridge = (
    window as unknown as { Capacitor?: { isNativePlatform?: () => boolean } }
  ).Capacitor;
  return bridge?.isNativePlatform?.() === true;
}
